/** Injects the CSRF token in XHR and fetch requests. Injecting in XHR means
 * both jQuery and axios use it.
 *
 * Injection code copied from jumpseller-2.0.0.js.
 */
export function setupAjax() {
  const token = document.querySelector("meta[name=csrf-token]")?.content;
  if (!token) return; // CSRF is disabled in tests

  // Inject CSRF in XMLHttpRequest.
  const originalXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    const opened = originalXhrOpen.apply(this, arguments);
    if (
      ["POST", "PATCH", "PUT", "DELETE"].includes(arguments[0]) &&
      isStorefrontBackendRequest(arguments[1])
    ) {
      this.setRequestHeader("X-CSRF-TOKEN", token);
    }
    return opened;
  };

  // Inject CSRF in fetch.
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = function () {
      if (
        ["POST", "PATCH", "PUT", "DELETE"].includes(arguments[1]?.method) &&
        isStorefrontBackendRequest(arguments[0])
      ) {
        (arguments[1].headers ??= {})["X-CSRF-TOKEN"] = token;
      }
      return originalFetch.apply(this, arguments);
    };
  }
}

/**
 * To add the CSRF token, request must go to our backend: URL is absolute with
 * the store as its origin or it is relative.
 *
 * As an example of why we added the URL verification, we have the epayco
 * payment modal's POST request that was failing because epayco cannot process
 * an OPTIONS request. This file sends the CSRF token which stops the request
 * from being considered simple, which forces the browser to send an OPTIONS
 * request.
 */
function isStorefrontBackendRequest(url) {
  return (
    new URL(url, window.location.origin).origin ==
    new URL(window.location.origin).origin
  );
}
